import { config } from 'config'
import { AuthenticationResult } from 'shared/types'

class Auth {
  static setTokensInfo({
    accessToken,
    refreshToken,
    idToken,
  }: AuthenticationResult) {
    localStorage.setItem(config.idTokenKey, idToken)
    localStorage.setItem(config.refreshTokenKey, refreshToken)
    localStorage.setItem(config.accessTokenKey, accessToken)
  }

  static getTokensInfo() {
    return {
      accessToken: localStorage.getItem(config.accessTokenKey),
      idToken: localStorage.getItem(config.idTokenKey),
      refreshToken: localStorage.getItem(config.refreshTokenKey),
    }
  }

  static isAuthenticated() {
    const { accessToken, idToken } = Auth.getTokensInfo()
    return !!(accessToken && idToken)
  }

  static logout() {
    localStorage.removeItem(config.accessTokenKey)
    localStorage.removeItem(config.idTokenKey)
    localStorage.removeItem(config.refreshTokenKey)
  }
}

export default Auth
